import { createLink } from '@tanstack/react-router'
import { ArrowRight } from 'lucide-react'
import React from 'react'
import { styled } from 'styled-components'

const NavigationButtonContainer = styled.a`
  background-color: transparent;
  color: ${({ theme }) => theme.forecast.activeText};
  opacity: 0.2;
  transition: opacity 0.2s;
  text-decoration: none;
  &:hover {
    opacity: 1;
    cursor: pointer;
  }
`

export const NavigationButtonComponent = React.forwardRef<
  HTMLAnchorElement,
  React.AnchorHTMLAttributes<HTMLAnchorElement>
>((props, ref) => (
  <NavigationButtonContainer ref={ref} {...props}>
    <ArrowRight size={'1rem'} />
  </NavigationButtonContainer>
))

NavigationButtonComponent.displayName = 'NavigationButton'

export const NavigationButton = createLink(NavigationButtonComponent)
